// Local memo of the appointment payment IN PROGRESS. Extracted from Reserver.jsx (B5) so
// CheckoutSuccess.jsx can clear it once the money has arrived.
//
// WHY IT EXISTS. A priced booking takes its time the moment it is created — the time's
// minutes are claimed, so `GET /api/availability` stops offering that start to everyone,
// the buyer included. A buyer who closes the Stripe tab would therefore find no time left
// to click, although the server would happily hand back the very same session
// (`service._resume_or_refuse`). This memo is the way back, on two routes:
//   • the page's "resume payment" banner links straight to `url`;
//   • `hold_token` is presented to `GET /api/availability?service_id=…` for the memo's
//     own `service_id`, which adds the held `start` back to that buyer's times, flagged
//     `held_by_you` — clicking it and submitting again resumes the same session.
//
// SHAPE (written by Reserver.jsx after a priced `POST /api/bookings/v2`):
//   { service_id: str, start: ISO-8601 UTC str, hold_token: str, email: str,
//     url: str (the Stripe Checkout URL), label: str (the service's name),
//     until: number (ms since epoch — the SERVER's `expires_at`, never a local guess) }
export const PENDING_KEY = "solunary_pending_booking";

export function readPending() {
  try {
    const raw = localStorage.getItem(PENDING_KEY);
    if (!raw) return null;
    const p = JSON.parse(raw);
    if (!p?.url || !p?.until || Date.now() > p.until) {
      localStorage.removeItem(PENDING_KEY); // the hold has expired: nothing left to resume
      return null;
    }
    return p;
  } catch (e) {
    return null;
  }
}

export function writePending(obj) {
  try {
    localStorage.setItem(PENDING_KEY, JSON.stringify(obj));
  } catch (e) { /* storage unavailable: the buyer still goes to pay */ }
}

export function clearPending() {
  try {
    localStorage.removeItem(PENDING_KEY);
  } catch (e) { /* already gone */ }
}
